console.log("MOLOTOF | Start");


/**
 * ----------------------------------------------------------------------------
 * Header color handler
 * ----------------------------------------------------------------------------
 */
const lavikaHeader = document.querySelector(".lavika-main-header");
const firstMainSection = document.querySelector("#main > section:first-child > div");
const headerWrapper = document.getElementById("shopify-section-lavika-header");
if(firstMainSection.classList.contains("with-white-header")){
  lavikaHeader.classList.add("white-header-enabled");
  lavikaHeader.classList.remove("black-header-enabled");
}else if(lavikaHeader.classList.contains("product-header")){
  headerWrapper.style = "mix-blend-mode: difference;"
  lavikaHeader.classList.add("white-header-enabled");
  lavikaHeader.classList.remove("black-header-enabled");
}else{
  lavikaHeader.classList.remove("white-header-enabled");
  lavikaHeader.classList.add("black-header-enabled");
}

document.addEventListener("scroll", ()=>{
  if (window.pageYOffset >= 50) {
    //console.log(window.pageYOffset);
    headerWrapper.style = "mix-blend-mode: none;"
    lavikaHeader.classList.remove("white-header-enabled");
    lavikaHeader.classList.add("is-scrolling");
  }
  if (window.pageYOffset == 0){
    lavikaHeader.classList.remove("is-scrolling");
    if(firstMainSection.classList.contains("with-white-header")){
      lavikaHeader.classList.add("white-header-enabled");
    }else if(lavikaHeader.classList.contains("product-header")){
      headerWrapper.style = "mix-blend-mode: difference;"
      lavikaHeader.classList.add("white-header-enabled");
      lavikaHeader.classList.remove("black-header-enabled");
    }else{
      lavikaHeader.classList.remove("white-header-enabled");
    }
  }
});


/**
 * ----------------------------------------------------------------------------
 * Swiper sliders
 * ----------------------------------------------------------------------------
 */

function initSwiper(sliderElm) {
    const desktopSlidesPerView = parseInt(`${sliderElm.dataset.slides}`);
    const loopable = `${sliderElm.dataset.loop}`;
    const sliderId = sliderElm.id;

    let nx;
    let pr;

    if(sliderElm.id == "product-swiper-home" || sliderElm.id == "categories-swiper"){
      nx = '.lavika-swiper-button-next';
      pr = '.lavika-swiper-button-prev';
    }else{
      nx = '.swiper-button-next';
      pr = '.swiper-button-prev';
    }

    console.log(nx);
    console.log(pr);

    let elementLoop = true;
    if(loopable == "true"){
        elementLoop = true;
    }else{
        elementLoop = false;
    }

    if(sliderId == "product-slider"){
    const allSlides = document.querySelectorAll(".swiper-slide");
    //console.log(allSlides);
    const initialSlideOnLoad = document.querySelector(".swiper-slide.is-initial");
    //console.log("InitialOnLoad: ", initialSlideOnLoad);

    let setInitialSlideNum = 0;
    if(initialSlideOnLoad != null){
      setInitialSlideNum = initialSlideOnLoad.dataset.imageMediaPosition
    }else{
      setInitialSlideNum = 0;
    }
      
     return new Swiper(`#${sliderElm.id}`, {
           initialSlide: setInitialSlideNum, 
            loop: false,
            draggable: true,
            slidesPerView: 1,
            spaceBetween: 0,
            keyboard: {
              enabled: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
      });

    }else{
      return new Swiper(`#${sliderElm.id}`, {
        
        loop: elementLoop,
        draggable: true,
        breakpoints: {
          320:{
            cssMode: true,
            slidesPerView: 1.3,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: desktopSlidesPerView,
            spaceBetween: 25
          }
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: nx,
          prevEl: pr
        }
      });

    }
    
}
  
let allSliders = document.querySelectorAll('.swiper:not(.swiper-no-custom)');
if(allSliders != null){
  allSliders.forEach((slider) => {
    initSwiper(slider);
  });
}



const searchIcon = document.querySelector(".search-icon svg");
if(searchIcon != null){
  searchIcon.style = "z-index: 1;";
}

const searchBar = document.getElementById("header-search-lavika-header");

if(searchBar != null){
  var searchBarObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "attributes") {
        if(mutation.target.hasAttribute("open")){
          lavikaHeader.classList.add("is-solid");
          if(lavikaHeader.classList.contains("product-header")){
            headerWrapper.style = "mix-blend-mode: none;"
          }
        }else{
          lavikaHeader.classList.remove("is-solid");
          if(lavikaHeader.classList.contains("product-header")){
            headerWrapper.style = "mix-blend-mode: difference;"
          }
        }
      }
      
    });
  });
  
  searchBarObserver.observe(searchBar, {
    attributes: open 
  });
}


/**
 * ----------------------------------------------------------------------------
 * Menu Drawer mobile tweaks
 * ----------------------------------------------------------------------------
 */

if (window.matchMedia("(max-width: 1023px)").matches){
  // Getting the secondary menu (drawer 2, which is white)
  const collapsibleHeaderPanel = document.querySelector(".header-sidebar__collapsible-panel");

  //Getting the sidebar menu (which is the whole thing)
  const sidebarMenu = document.getElementById("sidebar-menu");

  //Getting only the part where the close icon is
  const headerIconClose = sidebarMenu.shadowRoot.getElementById("lavika-part-header-content");

  //Getting the hamburger button
  const hamburger = document.querySelector(".header__primary-nav");


  hamburger.addEventListener("click", ()=>{
    //Getting the links of the 2 drawer which have sublinks
    const openableLink = document.querySelectorAll('[aria-controls="header-panel-1"]');

    //When I click this link, the upper part has to change color  
    openableLink.forEach(link => {
      link.addEventListener("click", ()=>{
        sidebarMenu.classList.add("secondary-sidebar-menu");
      });
    });
  });

  // Getting the back button (when clicked the close icon part has to re-change color)
  const backButton = document.querySelector(".header-sidebar__back-button");
  backButton.addEventListener("click", ()=>{
    sidebarMenu.classList.remove("secondary-sidebar-menu");
  });
}


/**
 * ----------------------------------------------------------------------------
 * FAQ
 * ----------------------------------------------------------------------------
 */
const stickyFaq = document.querySelector(".faq__toc");
if (stickyFaq != null){
  document.addEventListener("scroll", ()=>{
    if (window.pageYOffset >= 500) {
      stickyFaq.style = "transform: translateY(15rem); transition: transform .2s ease;"
    }
    if (window.pageYOffset <= 450){
      stickyFaq.style = "transform: translate(0); transition: transform .2s ease;"
    }
  });
  
}
const faqCategories = document.querySelectorAll(".faq__toc-item");
if(faqCategories != null){
  
  function removeCategoryActive() {
    faqCategories.forEach((category) => {
      category.classList.remove("is-active");
    })
  }

  faqCategories.forEach((category)=>{
    category.addEventListener("click", ()=>{
      if(!category.classList.contains("is-active")){
        removeCategoryActive();
        category.classList.add("is-active");
      }
    });
  });
}


/**
 * ----------------------------------------------------------------------------
 * Product Page accrdions
 * ----------------------------------------------------------------------------
 */
const productAccordions = document.querySelectorAll(".lavika-product-accordion-toggle");

if(productAccordions != null){
  productAccordions.forEach((accordion)=>{
    accordion.addEventListener("click", ()=>{
        accordion.querySelector("svg").classList.toggle("open");
    });
  });
}


/**
 * ----------------------------------------------------------------------------
 * Product Page share button
 * ----------------------------------------------------------------------------
 */

// Open share links
const shareButton = document.querySelector(".lavika-share-button");

if(shareButton != null){
  shareButton.addEventListener("click", ()=>{
    shareButton.querySelector(".share-img").classList.toggle("share-visible");
    shareButton.querySelector(".share-close").classList.toggle("share-visible");
    document.querySelector(".lavika-share-buttons").classList.toggle("share-visible");
  });

}

// Copy to clipboard desk
const clipboardItems = document.querySelectorAll(".desktop-clipboard");
if (clipboardItems != null) {
  const clipboardMessage = document.getElementById("copied-message");

  clipboardItems.forEach(item => {
    item.addEventListener("click", () => {
      const copyText = document.getElementById("desktop-url-to-copy");

      if (copyText != null) {
        navigator
          .clipboard
          .writeText(copyText.value)
          .then(() => {
            if (clipboardMessage != null) {
              clipboardMessage.classList.remove("d-none");

              setTimeout(() => {
                clipboardMessage.classList.add("d-none");
              }, "3000");
            }
          })
          .catch(() => {
            alert("sorry, something went wrong");
          });
      }

    });

  });
}


/**
 * ----------------------------------------------------------------------------
 * Multivideo section
 * ----------------------------------------------------------------------------
 */

const multivideoVideo = document.querySelector(".lavika-multivideo-video");

if(multivideoVideo != null){

  function removeCurrent(arr){
    arr.forEach((el)=>{
      el.classList.remove("current");
    });
  }

  // Desk
  const thumbnailRow = document.querySelectorAll(".thumbnail-row");
  thumbnailRow.forEach((row)=>{
    row.addEventListener("click", ()=>{
      removeCurrent(thumbnailRow);
      row.classList.add("current");
      multivideoVideo.src = `https://player.vimeo.com/video/${row.dataset.videoId}?autopause=1&transparent=0&responsive=1&portrait=1&title=0&byline=0`
    });
  });

  // Mob
  const mobileThumb = document.querySelectorAll(".mobile-thumb");
  const mobileThumbTitle = document.querySelector(".mobile-thumb-title .body-xs-mono-reg");
  mobileThumb.forEach((thumb)=>{
    thumb.addEventListener("click", ()=>{
      removeCurrent(mobileThumb);
      thumb.classList.add("current");
      multivideoVideo.src = `https://player.vimeo.com/video/${thumb.dataset.videoId}?autopause=1&transparent=0&responsive=1&portrait=1&title=0&byline=0`;
      mobileThumbTitle.innerHTML = thumb.dataset.videoTitle;
    });
  });
}


/**
 * ----------------------------------------------------------------------------
 * Banner shop page SOLO AL REFRESH IL RESTO è IN THEME.JS
 * ----------------------------------------------------------------------------
 */
/*
const discountBox = document.getElementById("discount-box");
const windowHref = window.location.href;
const windowSearch = window.location.search;

if(discountBox != null){
 
  const combineSpText = discountBox.dataset.combineSp;
  const combineRitualText = discountBox.dataset.combineRitual;
  const discountText = discountBox.dataset.discountText;
  
  if(windowHref.includes("custom.skin_personality") && windowHref.includes("custom.ritual")){
    console.log("tutto");
    if(discountBox.classList.contains("d-none")){
      discountBox.classList.remove("d-none");
    }
    discountBox.innerHTML = discountText;
  }
  if(windowHref.includes("filter.p.m.custom.skin_personality") && !windowHref.includes("ritual")){
    console.log("solo sp");
    if(discountBox.classList.contains("d-none")){
      discountBox.classList.remove("d-none");
    }
    discountBox.innerHTML = combineRitualText;
  }
  if(windowHref.includes("filter.p.m.custom.ritual") && !windowHref.includes("skin_personality")){
    console.log("solo ritual");
    if(discountBox.classList.contains("d-none")){
      discountBox.classList.remove("d-none");
    }
    discountBox.innerHTML = combineSpText;
  }

}*/